module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_8003.53a65808.png";